import { Injectable, OnDestroy } from "@angular/core";
import { toZonedTime } from "date-fns-tz";
import { Subject, Observable, map } from "rxjs";
import { WebAPIClient } from "./http-services/http-service";

export const DANISH_TIMEZONE = 'Europe/Copenhagen';

export interface ServerTime {
    serverTime: string;
}

@Injectable({ providedIn: 'root' })
export class TimeService implements OnDestroy {
    private destroy$ = new Subject<void>();
    private timeOffset = 0;

    constructor(private webAPIClient: WebAPIClient) { }

    getServerTime(): Observable<void> {
        return this.webAPIClient.get<ServerTime>(`/serverTime`).pipe(
            map(response => {
                const serverTime = new Date(response.serverTime).getTime();
                this.timeOffset = serverTime - Date.now();
            })
        );
    }

    // Returns server-synced time - used for ticket inspection
    now(): Date {
        return new Date(Date.now() + this.timeOffset);
    }

    // Returns server-synced time in Danish timezone as a plain Date object with seconds/ms zeroed
    nowInDenmark(): Date {
        const now = toZonedTime(this.now(), DANISH_TIMEZONE);
        now.setHours(now.getHours(), now.getMinutes(), 0, 0);
        return now;
    }

    isToday(date: Date): boolean {
        return date.toDateString() === this.nowInDenmark().toDateString();
    }

    toDanishTime(date: Date): Date {
        return toZonedTime(date, DANISH_TIMEZONE);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
